export const initialTabScrollState = { canScrollLeft: false, canScrollRight: false };
export const getCurrentTabScrollState = (tabList) => {
    const { scrollLeft, scrollWidth, clientWidth } = tabList;
    const canScrollLeft = scrollLeft > 0;
    const canScrollRight = scrollWidth > clientWidth + scrollLeft + 1; // + 1 to allow for IE calculation issue
    return { canScrollLeft, canScrollRight };
};
//# sourceMappingURL=scroll-state.js.map